import React from 'react';

import { PRIVACY_POLICY_HTML } from '#/utils';

const PrivacyPolicy = () => {
    return (
        <div className='bg-white rounded-lg px-10 py-8 flex flex-col gap-4 '>
            <h1 className='font-cormorant text-[40px] font-semibold text-textPrimary text-center'>Privacy Policy</h1>
            <div
                className='h-[calc(100dvh-265px)] overflow-y-auto text-gray500 font-inter text-base font-normal rich-text-content'
                dangerouslySetInnerHTML={{ __html: PRIVACY_POLICY_HTML }}
            />
        </div>
    );
};

export { PrivacyPolicy };
